import React from 'react';
import { Button, CardView, rem } from 'design-system';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import Text from 'design-system/Text';
import { StyleSheet } from 'react-native';
const SetupCard = ({ icon, title, subTitle, buttonText, buttonLeftIcon, onButtonPress, }) => (<CardView noMarginTop noMarginBottom withPadding>
    <SettingsItemIcon iconSize={44} style={styles.icon}>
      {icon}
    </SettingsItemIcon>
    <Text Text-16 flex style={styles.title}>
      {title}
    </Text>
    <Text TextThin-14 Secondary style={styles.subTitle}>
      {subTitle}
    </Text>
    <Button title={buttonText} leftIcon={buttonLeftIcon} onPress={onButtonPress} square hug brandReversed containerStyle={styles.setupButton}/>
  </CardView>);
const styles = StyleSheet.create({
    icon: {
        marginBottom: rem(16),
    },
    title: {
        marginBottom: rem(4),
    },
    subTitle: {
        marginBottom: rem(16),
    },
    setupButton: {
        alignSelf: 'flex-start',
    },
});
export default SetupCard;
